module.exports = __webpack_public_path__ + "static/media/baseline-aspect_ratio.3c756d57.svg";